module.exports = __webpack_public_path__ + "static/media/game_quest_desktop_en.20a92b3d.png";